<template>
	<component :is="tag" :class="settings.variants[variant]">
		<slot />
	</component>
</template>

<script setup>
import {defineSettings} from '../composables/component';
const settings = defineSettings('NkBox');

defineProps({
	variant: {
		type: String,
		required: false,
		default: 'default',
	},
	tag: {
		type: String,
		required: false,
		default: 'div',
	},
});
</script>
